export class ContractDetail {
	public id: number;
	public contractId: string;
	public supplierCommissionResponseReasonId: number;
	public supplierNote: string;

	constructor(contractDetail?: ContractDetail) {
		Object.assign(this, contractDetail);
	}
}
